/* eslint-disable no-underscore-dangle */

import React from "react";
import CancelablePromise from "cancelable-promise";

class VisibilityPoller extends React.Component {
	constructor(props) {
		super(props);

		this.promise = null;
		this.modifier = 1;

		this.runPoll = this.runPoll.bind(this);
		this.nextPoll = this.nextPoll.bind(this);
	}

	componentDidMount() {
		this.timer = setTimeout(
			this.runPoll,
			this.props.delay * 1000 || this.props.duration * 1000
		);

		if (!this.waiting) {
			this.runPoll();
		}
	}

	componentDidUpdate(prevProps) {
		if (this.props.duration < prevProps.duration && this.lastRun) {
			// If the duration has dropped update the poller to use the new duration
			// Or call if it should of run in the past
			clearTimeout(this.timer);
			this.timer = null;

			const whenShouldRun =
				this.props.duration * this.modifier * 1000 -
				(new Date().getTime() - this.lastRun);

			if (whenShouldRun < 0) {
				this.runPoll();
			} else {
				this.timer = setTimeout(this.runPoll, whenShouldRun);
			}
		}

		if (this.props.paused !== prevProps.paused) {
			if (!this.waiting) {
				this.runPoll();
			}
		}
	}

	componentWillUnmount() {
		if (this.promise) {
			this.promise.cancel();
		}
		clearTimeout(this.timer);
	}

	get waiting() {
		return this.promise || this.timer;
	}

	runPoll() {
		clearTimeout(this.timer);
		this.timer = null;

		if (this.props.paused) {
			return;
		}

		this.promise = new CancelablePromise((resolve, reject) =>
			this.props.poll().then(resolve, reject)
		).then(this.nextPoll, this.nextPoll);
	}

	nextPoll(res = {}) {
		if (this.promise._canceled) {
			return;
		}

		this.lastRun = new Date().getTime();
		this.promise = null;

		let delay = this.props.duration;
		if (res._headers && res._headers.get("poll_modifier")) {
			this.modifier = Number(res._headers.get("poll_modifier")) || 1;
			delay *= this.modifier;
		}

		this.timer = setTimeout(this.runPoll, delay * 1000);
	}

	render() {
		return null;
	}
}

export default VisibilityPoller;



// WEBPACK FOOTER //
// ./src/components/VisibilityPoller/index.js